import styled from 'styled-components';

interface Props {
  children: React.ReactNode;
}

export default function TableWrapper({ children }: Props): JSX.Element {
  return <StyledTableWrapper>{children}</StyledTableWrapper>;
}

const StyledTableWrapper = styled.div`
  .k-grid-header {
    thead {
      th {
        justify-content: flex-start;
      }
    }
  }
  border: none;
  width: 100%;
  display: table;
  th {
    border: none !important;
    color: #642b26;
    padding: 10px;
    vertical-align: bottom;
  }
  td {
    border: 1px solid #eeeeee !important;
    text-align: center;
    padding: 10px;
    background: #fff !important;
    color: #343434;
    vertical-align: middle;
  }
  tbody {
    tr {
      min-height: 41px;
    }
    tr:nth-child(1) {
      td:first-child {
        border-top-left-radius: 5px !important;
        background: #fff;
      }
      td:last-child {
        border-top-right-radius: 5px !important;
        background: #fff;
      }
    }
    tr:last-child {
      td:first-child {
        border-bottom-left-radius: 5px !important;
      }
      td:last-child {
        border-bottom-right-radius: 5px !important;
      }
    }
  }
`;
